// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2363":"fa546949f8a6f30e","2423":"9a9b780a2b87bc31","2888":"6882b797e1af2808","8724":"851bd7e1c446b003"}[chunkId] + ".css";
};